import { render } from "./PencilIcon.vue?vue&type=template&id=43afee42"
const script = {}
script.render = render

export default script